module.exports = __webpack_public_path__ + "media/images/gallery/eclipses/2000-12-25/2000-12-25_bme-32384869e9d0f75ababf5411d529f64b.gif";